import { createClient } from "@supabase/supabase-js";

const rawUrl = (process.env.REACT_APP_SUPABASE_URL || "").trim();
const supabaseAnonKey = (process.env.REACT_APP_SUPABASE_ANON_KEY || "").trim();

// Use relative proxy URL in production browser environment to bypass ISP/regional blocks
const supabaseUrl = (typeof window !== "undefined" && window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1")
  ? `${window.location.origin}/supabase`
  : rawUrl;

if (!supabaseUrl || !supabaseAnonKey) {
  // Keep boot explicit in dev when env is missing.
  // eslint-disable-next-line no-console
  console.warn("Supabase env vars are missing: REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY");
}

export const supabase = createClient(supabaseUrl || "", supabaseAnonKey || "", {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    lock: async (name, acquireTimeout, fn) => fn(),
  },
});

